import React from 'react';
import { Button } from "@/components/ui/button";
import { ArrowRight, Loader2 } from "lucide-react";
import { SiteOffice } from '@/services/siteOfficeService';

interface SiteOfficeActionsProps {
  isValid: boolean;
  isCreatingCustom: boolean;
  onProceed: () => void;
  siteOffices?: SiteOffice[];
}

const SiteOfficeActions = ({
  isValid,
  isCreatingCustom,
  onProceed,
  siteOffices = []
}: SiteOfficeActionsProps) => {

  return (
    <div className="w-full max-w-[1280px] mx-auto px-4 sm:px-6 space-y-8">
      {/* Continue Button Container */}
      <div className="flex justify-center pt-4 sm:pt-6">
        <Button 
          onClick={onProceed}
          disabled={!isValid || isCreatingCustom}
          className="group relative overflow-hidden bg-[#0284c7] hover:bg-[#0369a1] text-white px-6 sm:px-8 py-3 sm:py-4 text-base sm:text-lg font-semibold rounded-xl shadow-lg shadow-sky-900/20 hover:shadow-xl transition-all duration-300 transform hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none disabled:shadow-lg w-full sm:w-auto max-w-[400px]"
        >
          {/* Background Animation */}
          <div className="absolute inset-0 bg-gradient-to-r from-white/0 via-white/20 to-white/0 transform -skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-1000" />
          
          {/* Button Content */}
          <div className="relative flex items-center justify-center space-x-3">
            {isCreatingCustom ? (
              <>
                <Loader2 className="w-5 h-5 animate-spin" />
                <span>Creating Site Office...</span>
              </>
            ) : (
              <>
                <span>Continue to Application</span>
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-200" />
              </>
            )}
          </div>
        </Button>
      </div>
    </div>
  );
};

export default SiteOfficeActions;
